import './App.css';
import SortingViz from './components/SortingViz.js';
import Footer from './components/Footer.js';

function App() {
  return (
    <div className="App">
    
      <SortingViz/>
      
     <Footer/>
    </div>
  );
}

export default App;
